$mol_form_field $mol_labeler
	attr *
		^
		mol_form_field_state <= state null string
	bids /string
	label /
		<= name \
		<= Bid $mol_view
			sub / <= bid \
	content / <= control null
